import styled, { css } from "styled-components";
import media from "styled-media-query";
import { rem, rgba } from "polished";

import { themes } from "styles";

import { Ionicons } from "../../Icons";
import { IMessageProps } from "./interfaces";

export const Icon = styled(Ionicons)`
  margin-right: 8px;

  font-size: ${rem("16px")};

  ${media.greaterThan("huge")`
    margin-right: 16px;

    font-size: ${rem("22px")};
  `}
`;

export const Content = styled.div`
  flex: 1;

  line-height: 180%;
  font-size: ${rem("9px")};
  color: ${themes.text.medium};

  ${media.greaterThan("huge")`
    font-size: ${rem("13px")};
  `}
`;

export const Container = styled.div<IMessageProps>`
  position: relative;

  padding: 8px 16px 8px 20px;

  display: flex;
  align-items: center;

  font-weight: 600;
  border-radius: 8px;
  background-color: ${themes.page.colors.content};

  ${media.greaterThan("huge")`
    padding: 8px 16px 8px 24px;
  `}

  &:before {
    position: absolute;
    top: 50%;
    left: 8px;
    transform: translateY(-50%);

    width: 3px;
    height: 80%;

    display: block;

    content: "";
    border-radius: 30px;

    ${media.greaterThan("huge")`
      width: 4px;
    `}
  }

  ${(props) =>
    props.kind &&
    {
      info: css`
        &:before {
          background-color: ${themes.text.medium};
        }

        ${Icon} {
          color: ${themes.text.medium};
        }
      `,

      danger: css`
        background-color: ${rgba(themes.palletes.danger, 0.06)};

        &:before {
          background-color: ${themes.palletes.danger};
        }

        ${Content},
        ${Icon} {
          color: ${themes.palletes.danger};
        }
      `,

      warning: css`
        background-color: ${rgba(themes.palletes.warning, 0.06)};

        &:before {
          background-color: ${themes.palletes.warning};
        }

        ${Icon} {
          color: ${themes.palletes.warning};
        }
      `,

      success: css`
        &:before {
          background-color: ${themes.palletes.success};
        }

        ${Icon} {
          color: ${themes.palletes.success};
        }
      `,
    }[props.kind]}
`;
